<template>
  <v-container fluid class="pt-0 mt-0">
    <v-row>
      <v-col cols="12">
        <v-card class="mx-auto">
          <v-toolbar color="teal" dark class="text-xs-center">
            <v-toolbar-title style="color: white">Site Tools</v-toolbar-title>
          </v-toolbar>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-tabs style="max-width:100%" v-if="adminFunctions">
          <v-tab dense v-for="tab in adminFunctions" :key="tab.adminFunction" class="align-left">
            <v-icon left> {{ tab.icon }} </v-icon>
            {{ tab.adminFunction }}
          </v-tab>
          <v-spacer />
          <v-tab-item key="Migrate Avatars">
            <migrate-avatars />
          </v-tab-item>
          <v-tab-item key="Migrate Post Images">
            <migrate-post-images />
          </v-tab-item>
          <v-tab-item key="Migrate Journals">
            <migrate-journals />
          </v-tab-item>
        </v-tabs>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import MigrateAvatars from "../components/MigrateAvatars";
import MigratePostImages from "../components/MigratePostImages";
import MigrateJournals from "../components/MigrateJournals";

import serverFunctions from "@/functions/serverFunctions";
import userFunctions from "@/functions/userFunctions";

export default {
  components: {
    "migrate-avatars": MigrateAvatars,
    "migrate-post-images": MigratePostImages,
    "migrate-journals": MigrateJournals,
  },

  name: "SiteTools",
  methods: {
    requestSucceeded(result){
      if (!result || !result.success) {
        this.$router.push("/");
      }
    },
    requestFailed(){
      this.$router.push("/");
    }
  },
  data: () => ({
    nurseryLinks: null,
    adminFunctions: [
      { adminFunction: "Migrate Avatars", icon: "mdi-head" },
      { adminFunction: "Migrate Post Images", icon: "mdi-image" },
      { adminFunction: "Migrate Journals", icon: "mdi-folder" },
    ],
  }),
  beforeMount() {
    let userIsSiteDevRequest = serverFunctions.getDataRequestObject(
      userFunctions.getLoggedInUser(),
      null
    );

    serverFunctions.getRawPostResponse(
      "/isUserSiteDev",
      userIsSiteDevRequest
    ).then(this.requestSucceeded, this.requestFailed);

  },

};
</script>

<style scoped>
.palm-site-green {
  background-color: rgb(176, 217, 173);
}
</style>
